module.exports = __webpack_public_path__ + "static/media/kidsss.1d280003.png";